import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import PropTypes from 'prop-types';
import { apiRequest } from './apiService';

// Decode JWT token and store the extracted details
function decodeToken(token) {
	// console.log(token)
	// Check if token is a non-empty string
	if (typeof token !== 'string' || !token.trim()) {
		// console.error("Token is not a valid string");
		return null;
	}

	try {
		const decoded = jwtDecode(token);
		const requiredFields = ['userId', 'role', 'behavior', 'email', 'clientId'];
		requiredFields.forEach(field => {
			if (!(field in decoded)) {
				// console.warn(`Field "${field}" is missing in the decoded token`);
			}
		});
		// console.log(decoded)
		return decoded;
	} catch (error) {
		// console.error("Invalid token", error);
		return null;
	}
}

// Login service
// export const login = async (email, password) => {
// 	try {
// 		const response = await apiRequest('api/v1/auth/login', 'POST', { email, password });

// 		const loginData = response.data;
// 		// sessionStorage.clear();

// 		const decoded = decodeToken(loginData);
// 		// console.log(response)
// 		if (decoded) {
// 			sessionStorage.setItem('userName', decoded.username);
// 			sessionStorage.setItem('userId', decoded.userId);
// 			sessionStorage.setItem('role', decoded.role);
// 			sessionStorage.setItem('behavior', decoded.behavior);
// 			sessionStorage.setItem('email', decoded.email);
// 			sessionStorage.setItem('clientId', decoded.clientId);
// 			sessionStorage.setItem('authToken', loginData);
// 		}
// 	} catch (error) {
// 		throw error;
// 	}
// };

// Login service
export const login = async (email, password) => {
  try {
    const response = await apiRequest('api/v1/referral/login', 'POST', { email, password });

    // Backend returns token directly (string)
    const token = response?.data;

    if (!token || typeof token !== "string") {
      throw new Error("Invalid Credentials");
    }

    const decoded = decodeToken(token);

    if (decoded) {
      sessionStorage.setItem('userName', decoded.username);
      sessionStorage.setItem('userId', decoded.userId);
      sessionStorage.setItem('role', decoded.role);
      sessionStorage.setItem('behavior', decoded.behavior);
      sessionStorage.setItem('email', decoded.email);
      sessionStorage.setItem('clientId', decoded.clientId);
      sessionStorage.setItem('authToken', token);
    }

    // ✅ return something meaningful
    return { success: true, token, decoded };
  } catch (error) {
    throw new Error(error.response?.data?.message || "Invalid credentials");
  }
};


// Signup service
export const signup = async (userDetails) => {
	try {
		const data = await apiRequest('api/v1/auth/signup', 'POST', userDetails);
		// console.log('Signup Response:', data); 
		return data;
	} catch (error) {
		// console.error('Error during signup:', error);
		throw error;
	}
};

// Ensure prop-types for secure API calls
apiRequest.propTypes = {
	path: PropTypes.string.isRequired,
	method: PropTypes.oneOf(['GET', 'POST', 'PUT', 'DELETE']),
	body: PropTypes.object,
};